import StatusTag from '@/components/_common/StatusTag';
import {
  SpedDocumentStatusLabel,
  SpedDocumentStatusColor,
  SpedDocument,
} from '@/core/domain/sped/sped-documents/sped-documents.types';
import { Skeleton, Empty, Row, Col, Typography, Descriptions } from 'antd';
import moment from 'moment';

interface Props {
  loading: boolean;
  spedDocument?: SpedDocument;
}

export default function SpedDocumentDetailCard({
  loading,
  spedDocument,
}: Props) {
  return (
    <>
      <Skeleton loading={loading}>
        {!spedDocument && (
          <Empty description="Não foi possível encontrar os dados do documento SPED." />
        )}

        {!!spedDocument && (
          <>
            <Row style={{ marginBottom: 16 }}>
              <Col flex={1}>
                <Typography.Title level={4} style={{ margin: 0 }}>
                  Dados do documento SPED
                </Typography.Title>
              </Col>
            </Row>

            <Descriptions
              bordered
              column={{ xs: 1, sm: 1, md: 2 }}
              style={{ overflow: 'hidden' }}
            >
              <Descriptions.Item label="Empresa">
                {spedDocument.companyName}
              </Descriptions.Item>
              <Descriptions.Item label="Período">
                {moment([
                  Number(spedDocument.assessmentYear),
                  Number(spedDocument.assessmentMonth) - 1,
                  1,
                ]).format('MMMM/YYYY')}
              </Descriptions.Item>
              <Descriptions.Item label="Status">
                <StatusTag
                  label={SpedDocumentStatusLabel[spedDocument.status]}
                  color={SpedDocumentStatusColor[spedDocument.status]}
                />
              </Descriptions.Item>
            </Descriptions>
          </>
        )}
      </Skeleton>
    </>
  );
}
